import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const REMOVE_POSITION_PRICING_MUTATION = gql`
  mutation removePositionPricing (
    $documentVersion: DocumentVersionInput!,
    $lineId: String!,
    $priceLineId: String!,
    $stepId: String!,
    $withPricing: Boolean = true
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          removePricingCommand(priceLineId: $priceLineId, stepId: $stepId) {
            id
            ...QuotePricingFragment @include(if: $withPricing)
            ...QuotePricingStateFragment @skip(if: $withPricing)
            lines {
              id
              ...ProductLinePricingFragment @include(if: $withPricing)
              ...CustomLinePricingFragment @include(if: $withPricing)
            }
          }
        }
      }
    }
  }
  ${PRODUCT_LINE_PRICING_FRAGMENT}
  ${CUSTOM_LINE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class RemovePositionPricingMutation extends Mutation<RootMutation> {
  document = REMOVE_POSITION_PRICING_MUTATION;
}
